import { apiClient, API_CONFIG } from '../config/api'
import { Customer, CustomerRequest, CustomerSearchParams, CustomerStatistics } from '../types/customer'

const BM = API_CONFIG.BM_BASE_URL

export const customerService = {
  async getCustomers(params: CustomerSearchParams = {}) {
    const sp = new URLSearchParams()
    if (params.page) sp.append('page', params.page.toString())
    if (params.size) sp.append('size', params.size.toString())
    if (params.search) sp.append('search', params.search)
    if (params.customerType) sp.append('type', params.customerType)
    if (params.contractStatus) sp.append('status', params.contractStatus)
    if (params.sortBy) sp.append('sort', params.sortBy)
    if (params.sortOrder) sp.append('order', params.sortOrder)
    const { data } = await apiClient.get(`${BM}/customers?${sp}`)
    return data
  },

  async getCustomer(identifier: string): Promise<Customer> {
    const { data } = await apiClient.get(`${BM}/customers/${encodeURIComponent(identifier)}`)
    return data.data
  },

  async createCustomer(request: CustomerRequest): Promise<Customer> {
    const clean = Object.fromEntries(Object.entries(request).filter(([, v]) => v !== undefined && v !== null && v !== ''))
    const { data } = await apiClient.post(`${BM}/customers`, clean)
    return data.data
  },

  async updateCustomer(customerCode: string, request: CustomerRequest): Promise<Customer> {
    const { data } = await apiClient.put(`${BM}/customers/${encodeURIComponent(customerCode)}`, request)
    return data.data
  },

  async deleteCustomer(customerId: string): Promise<void> {
    await apiClient.delete(`${BM}/customers/${customerId}`)
  },

  async searchCustomers(searchTerm: string, limit = 10): Promise<Customer[]> {
    const { data } = await apiClient.get(`${BM}/customers/search`, { q: searchTerm, limit })
    return data.data
  },

  async getActiveCustomers(): Promise<Customer[]> {
    const { data } = await apiClient.get(`${BM}/customers`, { status: 'ACTIVE', size: 1000 })
    return data.data ?? []
  },

  async getCustomerStatistics(customerId: number): Promise<CustomerStatistics> {
    const { data } = await apiClient.get(`${BM}/customers/${customerId}/statistics`)
    return data.data
  },

  async getExpiringContracts(daysAhead = 30) {
    const { data } = await apiClient.get(`${BM}/customers/expiring-contracts`, { days: daysAhead })
    return data
  },

  async getOverduePayments() {
    const { data } = await apiClient.get(`${BM}/customers/overdue-payments`)
    return data
  },

  async getDashboardSummary() {
    const { data } = await apiClient.get(`${BM}/customers/dashboard-summary`)
    return data
  },
}
